import { TextField } from "@material-ui/core";

function InputSelect({ label, value, values, onChange, optStyle }) {
  const os = optStyle || {}
  return (
    <TextField
      select
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      InputLabelProps={{ shrink: true }}
      margin="dense"
    >
      {values.map((option) => (
        <option key={option.value} value={option.value} style={os}>
          {option.label}
        </option>
      ))}
    </TextField>
  );
}

export default InputSelect;
